import Service from "./Service";

import pick from "lodash/pick";

export default class ModelService extends Service {
  modelPath = "";
  modelName = "";
  Model;

  constructor(modelPath, Model, modelName = null) {
    super();
    this.modelPath = modelPath;
    this.modelName = modelName;
    this.Model = Model;
  }

  /* Gets the required data for the form */
  create() {
    return new Promise((resolve, reject) => {
      this.get(env.API_URL + this.modelPath + "/create")
        .then(data => {
          let item = new this.Model(data);
          resolve(item);
        })
        .catch(e => reject(e.response));
    });
  }

  /* Stores a value in the database */
  insert(model) {
    return new Promise((resolve, reject) => {
      this.post(
        env.API_URL + this.modelPath,
        this.modelName ? { [this.modelName]: model } : model
      )
        .then(data => {
          let item = new this.Model(data);
          resolve(item);
        })
        .catch(e => {
          reject(e.response);
        });
    });
  }

  /* Updates the model */
  update(model) {
    return new Promise((resolve, reject) => {
      this.put(
        env.API_URL + this.modelPath + "/" + model.id,
        this.modelName ? { [this.modelName]: model } : model
      )
        .then(data => {
          let item = new this.Model(data);
          resolve(item);
        })
        .catch(e => reject(e.response));
    });
  }

  /* Deletes the model */
  destroy(id) {
    return new Promise((resolve, reject) => {
      this.delete(env.API_URL + this.modelPath + "/" + id)
        .then(data => {
          let item = new this.Model(data);
          resolve(item);
        })
        .catch(e => reject(e?.response ? e.response : e));
    });
  }

  search(search = null, params = {}) {
    return new Promise((resolve, reject) => {
      this.post(env.API_URL + this.modelPath + "/search", {
        params: {
          search,
          page: params?.meta?.page || 1,
          ...params
        }
      })
        .then(data => {
          if (params.meta && params.meta.page) {
            data.data = this.Model.list(data.data);
            data.page = data.current_page;

            resolve(data);
          } else {
            resolve(this.Model.list(data));
          }
        })
        .catch(e => {
          if (e?.response?.status !== 401) console.log(e);
          reject(e.response);
        });
    });
  }

  find(id, qs = "") {
    return new Promise((resolve, reject) => {
      this.get(env.API_URL + this.modelPath + "/" + id + qs)
        .then(data => {
          let item = new this.Model(data);
          resolve(item);
        })
        .catch(e => reject(e.response));
    });
  }

  findAll(options = { initObject: true }) {
    return new Promise((resolve, reject) => {
      this.get(env.API_URL + this.modelPath)
        .then(data => {
          const items = options.initObject ? this.Model.list(data) : data;
          resolve(items);
        })
        .catch(e => reject(e.response));
    });
  }
}
